module.exports = __webpack_public_path__ + "media/images/career_camp/2022/career_pass_ticket-bf066e373e67fb1878c3c656beede342.svg";